import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { normalizeError } from "../../services/api";

export const fetchStats = createAsyncThunk(
  "stats/fetch",
  async ({ params = {}, silent = false } = {}, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/api/grievances/stats", { params });
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const fetchHeatmapData = createAsyncThunk(
  "stats/fetchHeatmap",
  async ({ params = {} } = {}, { rejectWithValue }) => {
    try {
      // Fetch heatmap counts
      const { data: heatData } = await api.get(
        "/api/grievances/stats/heatmap",
        { params }
      );

      let geoData = null;
      let acMandalsMap = null;

      if (heatData.level === "ac" && heatData.state) {
        // AP: Fetch AC GeoJSON for this state
        const { data } = await api.get(
          `/api/geo/acs/${encodeURIComponent(heatData.state)}`
        );
        geoData = data;
      } else if (heatData.level === "district" && heatData.state) {
        // Non-AP: Fetch district GeoJSON for this state
        const { data } = await api.get(
          `/api/geo/acs/${encodeURIComponent(heatData.state)}`
        );
        geoData = data;
      } else if (heatData.level === "mandal" && heatData.state && heatData.district) {
        // Non-AP: Fetch mandals for a specific district
        const { data } = await api.get(
          `/api/geo/mandals/${encodeURIComponent(heatData.state)}/${encodeURIComponent(heatData.district)}`
        );
        geoData = data;
      } else if (heatData.level === "mandal" && heatData.state) {
        // AP: Fetch mandal GeoJSON + AC→mandal mapping for this state
        const [mandalsRes, acMandalsRes] = await Promise.all([
          api.get(`/api/geo/mandals/${encodeURIComponent(heatData.state)}`),
          api.get(`/api/geo/ac-mandals/${encodeURIComponent(heatData.state)}`),
        ]);
        geoData = mandalsRes.data;
        acMandalsMap = acMandalsRes.data;
      }

      return { ...heatData, geoData, acMandalsMap };
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  },
  {
    condition({ params = {} } = {}, { getState }) {
      const { stats } = getState();
      if (!stats.heatmapCounts) return true;
      const prev = stats.heatmapLastParams;
      if (prev && JSON.stringify(params) === JSON.stringify(prev)) return false;
      return true;
    },
  }
);
